module.exports = __webpack_public_path__ + "static-v-shop/1765575532973/img/logo_cabal.f797e5ff.png";